import { AnimatePresence, motion } from "motion/react";
import { X } from "@phosphor-icons/react";
import { Icon } from "@shopflo/ui/icon";

interface TrayPopoverProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

// Overlay rendered inside the tray container: dim layer + bottom card over the product grid
export const TrayPopover = ({ open, title, onClose, children }: TrayPopoverProps) => (
  <AnimatePresence>
    {open && (
      <div className="absolute inset-0 z-20 overflow-hidden rounded-t-[28px]">
        <motion.div
          className="absolute inset-0 bg-black/10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          onClick={onClose}
        />
        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "100%" }}
          transition={{ type: "spring", bounce: 0, duration: 0.4 }}
          className="absolute bottom-0 inset-x-0 rounded-t-[20px] bg-white px-5 pb-4 pt-6 "
>
          <div className="relative flex items-center justify-center pb-3">
            <p className="text-text-sm-semibold uppercase tracking-[0.56px] text-zinc-500">{title}</p>
            <button
              type="button"
              onClick={onClose}
              className="absolute right-0  p-1 hover:bg-shade-4
              "
              aria-label="Close">
              <Icon IconComponent={X} size="sm" className="text-zinc-500"  />
            </button>
          </div>
          {children}
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);
